// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d7631c4b","732":"8ccef581","977":"caa21d7c"}[chunkId] + ".chunk.js";
};